export default [
  [`Размеры`, `2XS`, `XS`, `S`, `M`, `L`, `XL`],
  [`Российский размер`, `40`, `42`, `44`, `46`, `48`, `50`],
  [`Рост`, `164`, `164`, `170`, `170`, `170`, `170`],
  [`Обхват груди(a)`, `80`, `84`, `88`, `92`, `96`, `100`],
  [`Обхват бедер (b)`, `86`, `90`, `94`, `98`, `102`, `106`],
  [`Длина спины по центру (c)`, `85`, `85`, `87`, `90`, `93`, `96`],
  [`Ширина на уровне проймы (d)`, `44`, `46`, `48`, `51`, `54`, `56`],
  [`Ширина талии (e)`, `40.5`, `43`, `45`, `48`, `50`, `53`],
  [`Ширина бёдер (f)`, `46`, `48`, `50`, `53`, `56`, `58`],
  [`Ширина низа (g)`, `46`, `48`, `50`, `52`, `55`, `58`],
  [`Ширина рукава вверху (h)`, `16`, `17`, `18`, `19`, `19`, `20`],
  [`Длина рукава (i)`, `46`, `46`, `47`, `47`, `48`, `48`]
];
